import React, { useEffect } from 'react';
import { X } from 'lucide-react';

// The API supplies only reasons tied to catalogue products actually shown in
// this answer. Never build brand claims from card names in the client.
export default function BrandReasonsSheet({ reasons, onClose }) {
  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  if (!Array.isArray(reasons) || reasons.length === 0) return null;
  return (
    <div className="fixed inset-0 z-[80] flex items-end justify-center p-2" role="presentation">
      <button type="button" className="absolute inset-0 bg-[#1C243A]/40"
        aria-label="Close brand explanation" onClick={onClose} />
      <section role="dialog" aria-modal="true" aria-label="Why these brands?"
        className="relative w-full max-w-[430px] max-h-[85dvh] overflow-y-auto rounded-[22px] bg-white shadow-2xl pb-[max(20px,env(safe-area-inset-bottom))]">
        <div className="flex items-center justify-between gap-3 px-5 py-4 border-b border-[#2A324B]/10">
          <h2 className="text-[18px] font-semibold text-[#341C1C]">Why these brands?</h2>
          <button type="button" onClick={onClose} aria-label="Close"
            className="flex h-11 w-11 items-center justify-center rounded-full text-[#2A324B]">
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="px-5 pt-4 text-[14px] leading-relaxed text-[#2A324B]">
          <p>These brands made this shortlist through the products below. Brand placement is not paid, and we earn no commission from these picks.</p>
          <div className="mt-4 divide-y divide-[#2A324B]/10 border-t border-[#2A324B]/10">
            {reasons.map(({ brand, product_id, reason }) => (
              <div key={product_id} className="py-3">
                <h3 className="font-semibold">{brand}</h3>
                <p className="mt-1 text-[#2A324B]/75">{reason}</p>
              </div>
            ))}
          </div>
          <p className="mt-4 text-[12px] text-[#2A324B]/60">See the full reasoning in the answer for product, formula and shade details.</p>
        </div>
      </section>
    </div>
  );
}
